import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { LayoutService } from "../../../shared/services/layout.service";
import { ComponentCommunicationService } from "../../../shared/services/component-communication.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  rightPanelStatus = false;
  cs: ComponentCommunicationService;
  @Input() navLayout: string;
  @Input() defaultNavbar: string;
  @Input() toggleNavbar: string;
  @Input() toggleStatus: boolean;
  @Input() navbarEffect: string;
  @Input() deviceType: string;
  @Input() headerColorTheme: string;
  @Input() leftHeaderColorTheme: string;
  @Input() navbarColorTheme: string;
  @Input() activeNavColorTheme: string;
  @Input() headerHeight: number;
  @Input() collapsedLeftHeader: boolean;
  constructor(private layoutService: LayoutService, public _router: Router) {}

  ngOnInit() {}

  changeTheToggleStatus() {
    this.layoutService.getToggleStatus();
  }

  changeTheRightPanelStatus() {
    this.rightPanelStatus = !this.rightPanelStatus;
        this.layoutService.rsToggleStatus.next(this.rightPanelStatus);
    // this.cs.dataEmitter();
  }

  LogOut() {
    const user = JSON.parse(sessionStorage.getItem("currentUser_EPC_Portfolio"));
    if (user) {
      sessionStorage.removeItem("currentUser_EPC_Portfolio");
      sessionStorage.removeItem("secretKey");
      sessionStorage.removeItem("userKey");
      this._router.navigate(["/login"]);
    }
  }
}
